<template>
  <div class="flex flex-col items-center gap-4 text-center text-sm text-foreground">
    <template v-if="isLoading">
      <loader-circle-icon class="size-6 animate-spin text-primary" />
      <p class="m-0">{{ tr('Verifying your email address...') }}</p>
    </template>

    <template v-else-if="isSuccess">
      <p class="m-0">
        {{ tr('Your email address has been verified.') }}
        <br>
        {{ tr('You will be redirected to the login page in a few seconds.') }}
      </p>
      <router-link to="/auth/login" class="text-sm font-semibold text-foreground underline decoration-muted-foreground/50 underline-offset-4 hover:text-primary">
        {{ tr('Click here if you are not redirected automatically') }}
      </router-link>
    </template>

    <template v-else>
      <p class="m-0">{{ errorMessage }}</p>
      <p class="m-0 text-muted-foreground">
        {{ tr('Please try logging in again to receive a new verification email.') }}
      </p>
      <ui-button as-child class="mt-2">
        <router-link to="/auth/login">
          {{ tr('Go to Login') }}
        </router-link>
      </ui-button>
    </template>
  </div>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import AuthService from '@/services/Auth.js';

export default {
  name: 'VerifyEmailView',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  data: () => ({
    isLoading: true,
    isSuccess: false,
    errorMessage: '',
  }),
  computed: {
    title() {
      if (this.isLoading) {
        return this.tr('Email Verification');
      }
      if (this.isSuccess) {
        return this.tr('Email Verified Successfully!');
      }
      return this.tr('Verification Failed');
    },
  },
  watch: {
    title: {
      immediate: true,
      handler(val) {
        this.$emit('override-title', val);
        this.$emit('center-title');
      },
    },
  },
  created() {
    this.verifyEmail();
  },
  methods: {
    verifyEmail() {
      const token = this.$route.params.token;

      AuthService.verifyEmail(token)
        .then(() => {
          this.isSuccess = true;
          this.$toast.success(this.tr('Your email has been successfully verified! Redirecting to login...'));

          setTimeout(() => {
            this.$router.replace('/auth/login');
          }, 3000);

          return true;
        })
        .catch(() => {
          this.isSuccess = false;

          this.errorMessage = this.tr('An error occurred during email verification.');
          this.$toast.error(this.tr('An error occurred during email verification.'));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
